
    import { mapState, mapGetters } from 'vuex';
    import {
        faExclamationTriangle as farExclamationTriangle,
    } from '@fortawesome/pro-regular-svg-icons/faExclamationTriangle';

    import {
        faEllipsisVertical as farEllipsisVertical,
    } from '@fortawesome/pro-regular-svg-icons/faEllipsisVertical';

    import JobViewJobTitle from '@/components/JobView/JobViewJobTitle';
    import JobViewSubtitle from '@/components/JobView/JobViewSubtitle';
    import ScoreButton from '@/components/Scoring/ScoreButton';
    import JobViewApplyOnsite from '@/components/JobView/JobViewApplyOnsite';
    import JobViewApplyOffsite from '@/components/JobView/JobViewApplyOffsite';
    import JobViewPaySummary from '@/components/JobView/JobViewPaySummary';
    import JobViewPills from '@/components/JobView/JobViewPills';
    import JobViewApplyCta from '@/components/JobView/JobViewApplyCta';
    import JobViewPayInsightsButton from '@/components/JobView/JobViewPayInsightsButton';

    export default {
        name: 'JobViewHeader',

        components: {
            JobViewJobTitle,
            JobViewSubtitle,
            ScoreButton,
            JobViewApplyOnsite,
            JobViewApplyOffsite,
            JobViewPaySummary,
            JobViewPills,
            JobViewApplyCta,
            JobViewPayInsightsButton,
        },

        props: {
            showPayInsight: {
                type: Boolean,
                default: true,
            },
        },

        data() {
            return {
                carouselHeight: 205,
                shouldCompanyShow: false,
                showPromptModal: false,
                onBoardingPrompt: {
                    component_name: 'OnBoardingPrompt',
                    layout: 'lg',
                    code: 'ON_BOARDING_PROMPT',
                    page_referral_element: 'score_button',
                },
                icons: {
                    farExclamationTriangle,
                    farEllipsisVertical,
                },
            };
        },

        computed: {
            ...mapState({
                $_job: state => state.job.job,
                $_me: state => state.me.user,
                $_jobApplication: state => state.jobApplication,
                $_appInfo: state => state.appInfo,
                $_isApplyEnabled: state => state.job.is_apply_enabled,
            }),

            ...mapGetters('job', {
                $_jobTitle: 'jobTitle',
                $_companyName: 'companyName',
                $_companyLogoUrl: 'companyLogoUrl',
                $_companySquareLogoUrl: 'companySquareLogoUrl',
                $_companyLink: 'companyLink',
                $_companyPrimaryColor: 'companyPrimaryColor',
                $_companyMedias: 'companyMedias',
                $_primaryCompanyName: 'primaryCompanyName',
                $_primaryCompanyLink: 'primaryCompanyLink',
                $_displayPrimaryBrandCrumb: 'displayPrimaryBrandCrumb',
                $_isApplyDisabled: 'isApplyDisabled',
                $_locationLabel: 'locationLabel',
                $_locationLink: 'locationLink',
                $_isPrivateListing: 'isPrivateListing',
                $_isPayHidden: 'isPayHidden',
            }),
        },

        created() {
            if (this.$device.isTablet) {
                this.carouselHeight = 400;
            }

            if (this.$device.isDesktop) {
                this.carouselHeight = 220;
            }
        },

        methods: {
            openPromptModal() {
                this.showPromptModal = true;
            },

            closePromptModal() {
                this.showPromptModal = false;
            },
        },
    };
